import React from 'react';
import { XIcon } from 'lucide-react';
interface DatenschutzModalProps {
  onClose: () => void;
}
export function DatenschutzModal({
  onClose
}: DatenschutzModalProps) {
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-31">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto" data-id="element-32">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl" data-id="element-33">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-34">
            Datenschutzerklärung
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-35">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-36" />
          </button>
        </div>
        <div className="p-6 space-y-6 text-gray-700 leading-relaxed" data-id="element-37">
          <section data-id="element-38">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-39">
              1. Verantwortlicher
            </h3>
            <p data-id="element-40">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser
              Website ist:
            </p>
            <p className="mt-2" data-id="element-41">
              INTIGOO! GmbH
              <br data-id="element-42" />
              Werner-von-Siemens-Straße 33
              <br data-id="element-43" />
              49124 Georgsmarienhütte
            </p>
            <p className="mt-2" data-id="element-44">
              <strong data-id="element-45">Telefon:</strong> +49 5401 4977 0
              <br data-id="element-46" />
              <strong data-id="element-47">E‑Mail:</strong>{' '}
              <a href="mailto:info@intigoo.de" className="text-blue-600 hover:underline" data-id="element-48">
                info@intigoo.de
              </a>
            </p>
            <p className="mt-2" data-id="element-49">
              Verantwortliche Stelle ist die natürliche oder juristische Person,
              die allein oder gemeinsam mit anderen über die Zwecke und Mittel
              der Verarbeitung von personenbezogenen Daten (z.&nbsp;B. Namen,
              E‑Mail-Adressen o.&nbsp;Ä.) entscheidet.
            </p>
          </section>

          <section data-id="element-50">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-51">2. Hosting</h3>
            <p data-id="element-52">Diese Website wird bei Amazon Web Services (AWS) gehostet.</p>
            <p className="mt-2" data-id="element-53">Anbieter in Europa ist:</p>
            <p className="mt-1" data-id="element-54">
              Amazon Web Services EMEA SARL
              <br data-id="element-55" />
              38 Avenue John F. Kennedy
              <br data-id="element-56" />
              L-1855 Luxemburg
            </p>
            <p className="mt-3" data-id="element-57">
              Beim Aufruf dieser Website werden durch den Hosting-Anbieter
              automatisch folgende Daten verarbeitet:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-58">
              <li data-id="element-59">IP-Adresse</li>
              <li data-id="element-60">Datum und Uhrzeit des Zugriffs</li>
              <li data-id="element-61">Browsertyp und Browserversion</li>
              <li data-id="element-62">verwendetes Betriebssystem</li>
              <li data-id="element-63">Referrer-URL</li>
              <li data-id="element-64">Hostname des zugreifenden Rechners</li>
            </ul>
            <p className="mt-3" data-id="element-65">
              Diese Daten werden in sogenannten Server-Logfiles gespeichert.
            </p>
            <p className="mt-2" data-id="element-66">
              Die Verarbeitung erfolgt auf Grundlage von Art.&nbsp;6 Abs.&nbsp;1
              lit.&nbsp;f DSGVO (berechtigtes Interesse an der sicheren und
              stabilen Bereitstellung der Website).
            </p>
            <p className="mt-2" data-id="element-67">
              Mit AWS besteht ein Vertrag zur Auftragsverarbeitung gemäß
              Art.&nbsp;28 DSGVO.
            </p>
            <p className="mt-2" data-id="element-68">
              Sofern eine Verarbeitung außerhalb der Europäischen Union erfolgt,
              geschieht dies auf Grundlage geeigneter Garantien gemäß
              Art.&nbsp;44&nbsp;ff. DSGVO (insbesondere
              EU-Standardvertragsklauseln).
            </p>
          </section>

          <section data-id="element-69">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-70">3. Cookies</h3>
            <p data-id="element-71">
              Diese Website verwendet ausschließlich technisch notwendige
              Cookies, soweit dies für den Betrieb erforderlich ist.
            </p>
            <p className="mt-2" data-id="element-72">
              Es werden keine Analyse-, Tracking- oder Marketing-Cookies
              eingesetzt.
            </p>
            <p className="mt-2" data-id="element-73">
              Eine Einwilligung über ein Cookie-Banner ist daher nicht
              erforderlich.
            </p>
          </section>

          <section data-id="element-74">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-75">
              4. Speicherdauer
            </h3>
            <p data-id="element-76">
              Server-Logfiles werden vom Hosting-Anbieter automatisch nach einem
              angemessenen Zeitraum gelöscht.
            </p>
          </section>

          <section data-id="element-77">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-78">5. Ihre Rechte</h3>
            <p data-id="element-79">Sie haben das Recht auf:</p>
            <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-80">
              <li data-id="element-81">Auskunft (Art.&nbsp;15 DSGVO)</li>
              <li data-id="element-82">Berichtigung (Art.&nbsp;16 DSGVO)</li>
              <li data-id="element-83">Löschung (Art.&nbsp;17 DSGVO)</li>
              <li data-id="element-84">Einschränkung der Verarbeitung (Art.&nbsp;18 DSGVO)</li>
              <li data-id="element-85">Datenübertragbarkeit (Art.&nbsp;20 DSGVO)</li>
              <li data-id="element-86">Widerspruch (Art.&nbsp;21 DSGVO)</li>
            </ul>
            <p className="mt-3" data-id="element-87">
              Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an die
              oben genannten Kontaktdaten.
            </p>
          </section>

          <section data-id="element-88">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-89">
              6. Beschwerderecht
            </h3>
            <p data-id="element-90">
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde
              zu beschweren.
            </p>
          </section>
        </div>
      </div>
    </div>;
}